module.exports = __webpack_public_path__ + "img/power.db02367f.svg";